module.exports = __webpack_public_path__ + "static/img/kjdy17.64de9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy17.png
// module id = 332
// module chunks = 0